export enum MutationList {
    SAVE_APPOINTMENT = 'SAVE_APPOINTMENT',
    TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR',
    SPLICE_APPOINTMENT_FROM_APPOINTMENT_ARRAY = 'SPLICE_APPOINTMENT_FROM_ARRAY',
    SET_TRANSITION = 'SET_TRANSITION',
    ADD_HISTORY_COUNT = 'ADD_HISTORY_COUNT',
    REMOVE_HISTORY_COUNT = 'REMOVE_HISTORY_COUNT',
    SET_BACKWARDS_TRUE= 'SET_BACKWARDS_TRUE',
    SET_BACKWARDS_FALSE= 'SET_BACKWARDS_FALSE'
}